import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { WorkUnitOutputDTO } from './workUnitDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class WorkUnitServices {
  async getById(id: number): Promise<WorkUnitOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/work-unit/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAll(params: any): Promise<WorkUnitOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/work-unit/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByParam(params: object, queryParamsString = null): Promise<WorkUnitOutputDTO[]> {
    try {
      let url = `${process.env.REACT_APP_URL_RESERVATION}/work-unit/`

      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }

      const res = await axios.get(url, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByOrderParent(user_id: string): Promise<WorkUnitOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/work-unit/user/`, {
        headers: { 'authentication-token': getJWT()! },
        params: user_id ? { user_id: user_id } : undefined,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const workUnitServices = new WorkUnitServices()
